import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";

"use strict";
ko.bindingHandlers.actionmodeleditor = {
    init: function(elt, va, allbindings, model, context) {
        var action_model = va();
        var editor = {
            "fields": action_model.fields,
            "transitions": action_model.transitions
        };
        $.extend(editor, {
            "addField": function(ui, ev) {
                editor.fields.push({
                    "field": ko.observable(),
                    "caption": ko.observable(),
                    "data_type": ko.observable("string"),
                    "is_entity": ko.observable(false),
                    "validators": ko.observableArray([]),
                    "multiple": ko.observable(false)
                });
                
            },
            "removeField": function(ui, ev) {
                console.log("removing field:", ev, ui);
                var idx = editor.fields().indexOf(ui);
                if (idx >= 0) {
                    editor.fields.splice(idx, 1);
                }
            }
        });
        var childContext = context.createChildContext(editor);
        ko.applyBindingsToDescendants(childContext, elt);
        return {"controlsDescendantBindings":true};
    }, 
    update: function(elt, va, allbindings, model, context) {
        
    }
};

function known_controls() {
    return [
        {
            "class":"text",
            "thumbnail":"<i class='fa fa-text'></i> <span>Static Text</span>",
            "definition":function() {
                return {
                    "class":"text",
                    "text": ko.observable(null),
                    "caption": ko.observable(null)
                };
            }
        }
    ];
}

function process_fields(layout, fields) {
    console.log("processing fields:", layout, fields);
    if (layout == "tab" || layout == "wizard") {
        var c = fields[0];
        if (c && (c.class == "wizard"  || c.class == "tab")) {
            fields = c.fields;
        }
        var steps = [];
        var unloved = [];
        fields.forEach(function(f) {
            if (f.class == "wizardstep" || f.class == "tabpane") {
                steps.push(f);
            } else {
                unloved.push(f);
            }
        });
        if(unloved.length) {
            steps.push({ "class": layout == "tab" ? "tabpane": "wizardstep", "caption": _("action_model_editor_caption_untitled", "Untitled"), "fields": ko.observableArray(unloved) });
        }
        return steps;
    } else  {
        c = fields[0];
        if (c && (c.class == "wizard" || c.class == "tab")) {
            fields = c.fields;
        }
        fields = fields.map(function(f) {
            if (f && (f.class == "wizardstep" || f.class == "tabpane")) {
                return f.fields;
            }
            if (f) return [f];
            return null;
        }).filter(function(f) { return f && f.length; });
        return Array.prototype.concat.apply([], fields);
    }
}

function getInsertionContainer(elt, layout, fields, ui) {
    
    if (layout == "tab" || layout == "wizard") {
        var $activeTab = $(elt).find(".modal-body ul.nav > li.active");
        if (!$activeTab.data("notcontainer")) {
            var parent = ko.dataFor($activeTab[0]);
            if (!ko.isObservable(parent.fields)) {
                parent.fields = ko.observableArray([]);
            }
            return parent.fields;
        }
    } else {
        return fields;
    }
}

ko.bindingHandlers.dialogeditor = {
    init: function(elt, va, allbindings, model, context) {
        var dialog_model = {
            "buttons": ko.observableArray([]),
            "fields": ko.observableArray([]),
            "input_model": allbindings().model,
            "known_controls": ko.observableArray(known_controls()),
            "title": ko.observable(),
            "layout": ko.observable("tab"),
            "addControl": function(ui, ev) {
                console.log("add control:", ev, ui);
                var control = Object.assign({}, ui);
                var collection = getInsertionContainer(elt, dialog_model.layout(), dialog_model.fields(), ui);
                if (collection && control)
                    collection.push(Object.assign({ "editing": ko.observable(false) }, control.definition()));
            },
            "editControl": function(ui, ev) {
                if (ui.editing())
                    ui.editing(false);
                else {
                    dialog_model.fields().forEach(function(f) {
                        if (f) {
                            if (f.editing && f.editing()) {
                                f.editing(false);
                            }
                            if (f.fields) {
                                f.fields().forEach(function(ff) {
                                    if (ff && ff.editing && ff.editing()) {
                                        ff.editing(false);
                                    }
                                });
                            }
                        }
                    });
                    ui.editing(true);
                }
            },
            "removeControl": function(control, parent) {
                if (control && parent && parent.fields) {
                    var idx = parent.fields().indexOf(control);
                    if (idx >= 0) {
                        parent.fields.splice(idx, 1);
                    }
                }
            },
            "addFieldControl": function(ui, ev) {
                console.log("add field:", ev, ui);
                var control = null;
                if (ko.unwrap(ui.is_entity())) {
                    control = {
                        "class": "searchbox",
                        "entity": ko.observable(ko.unwrap(ui.data_type)),
                        "caption": ko.observable(ko.unwrap(ui.caption)),
                        "field": ko.unwrap(ui.field),
                        "multiple": ko.unwrap(ui.multiple)
                    };
                } else {
                    switch(ko.unwrap(ui.data_type)) {
                    case "string":
                        control = {
                            "class": "textbox",
                            "caption": ko.observable(ko.unwrap(ui.caption)),
                            "field": ko.unwrap(ui.field)
                        };
                        break;
                    case "integer":
                    case "numeric":
                        control = {
                            "class": "spinner",
                            "caption": ko.observable(ko.unwrap(ui.caption)),
                            "field": ko.observable(ui.field)
                        };
                        break;
                    case "currency":
                        control = {
                            "class": "currency",
                            "caption": ko.observable(ko.unwrap(ui.caption)),
                            "field": ko.observable(ui.field)
                        };
                        break;
                    case "datetime":
                    case "date":
                        control = {
                            "class": ko.unwrap(ui.data_type),
                            "caption": ko.observable(ko.unwrap(ui.caption)),
                            "field": ko.observable(ui.field)
                        };
                        break;
                    case "text":
                        control = {
                            "class": "textarea",
                            "caption": ko.observable(ko.unwrap(ui.caption)),
                            "rich_text": ko.observable(false),
                            "field": ko.observable(ui.field)
                        };
                        break;
                    }
                }
                if (control) {
                    control.editing = ko.observable(false);
                    var collection = getInsertionContainer(elt, dialog_model.layout(), dialog_model.fields(), ui);
                    if (collection)
                        collection.push(control);
                    
                }
                
            },
            "moveControlUp": function(ev, ui) {
                
            },
            "moveControlDown": function(ev, ui) {
            },
            "saveDialog": function(ev, ui) {
                var fields = ko.unwrap(dialog_model.fields);
                var title = ko.unwrap(dialog_model.title);
                var layout = ko.unwrap(dialog_model.layout);
                var buttons = ko.unwrap(dialog_model.buttons);
                if (ko.isObservable(va())) {
                    var spec = ko.unwrap(va());
                    Object.assign(spec, { fields: fields, title: title, layout:layout, buttons: buttons });
                    va()(spec);
                }
            },
            "addTab": function(ev, ui) {
                dialog_model.fields.push( { "class": dialog_model.layout() == "tab" ? "tabpane" : "wizardstep", "caption": ko.observable(_("action_model_editor_untitled", "Untitled")), "fields": ko.observableArray([]) });
            },
            "removeTab": function(ev, ui) {
                console.log("remove tab:", ev, ui);
            }
            
        };
        $.extend(dialog_model, {
            "isWizard": ko.pureComputed(function() {
                return dialog_model.layout() == "wizard";
            }),
            "isTab": ko.pureComputed(function() {
                return dialog_model.layout() == "tab";
            }),
            "isSingle": ko.pureComputed(function() {
                return dialog_model.layout() != "wizard" && dialog_model.layout() != "tab";
            })
        });
        var childContext = context.createChildContext(dialog_model);
        $(elt).data("dialogeditor", dialog_model);
        ko.applyBindingsToDescendants(childContext, elt);
        return {"controlsDescendantBindings":true};
    },
    update: function(elt, va, allbindings) {
        var dialog_model = $(elt).data("dialogeditor");
        var dialog_spec = ko.unwrap(va()) || {};
        var layout = ko.isObservable(dialog_model.layout) ? dialog_model.layout.peek() : dialog_model.layout;
        dialog_model.title(ko.unwrap(dialog_spec.title));
        dialog_model.buttons(ko.unwrap(dialog_spec.buttons) || []);
        dialog_model.fields(process_fields(layout, ko.unwrap(dialog_spec.fields) || []));
    }
};

var _controls = {
    "text": "control-text-tmpl",
    "datetime": "control-datetime-tmpl",
    "textbox": "control-textbox-tmpl",
    "searchbox": "control-searchbox-tmpl",
    "currency": "control-currency-tmpl",
    "spinner": "control-spinner-tmpl",
    "textarea": "control-textarea-tmpl"
};

ko.bindingHandlers.control = {
    make_template_obs: function(va) {
        return function() {
            return ko.pureComputed(function() {
                var data = ko.unwrap(va());
                if (!data) return null;
                return _controls[data.class] || _controls.text;
            });
        };
    },
    init: function(elt, va, allbindings, model, context) {
        return ko.bindingHandlers.template.init(elt, ko.bindingHandlers.control.make_template_obs(va), allbindings, model, context);
    },
    update: function(elt, va, allbindings, model, context) {
        return ko.bindingHandlers.template.update(elt, ko.bindingHandlers.control.make_template_obs(va), allbindings, model, context);
    }
};
